/**
 * Creates a record of action types based on an array of action type keys.
 * Each key from the input array will become a key in the resulting object,
 * with its corresponding value being the key itself in uppercase.
 * 
 * @template T - A union type derived from the string literals of the input array.
 * @param types - An array of strings representing action type keys.
 * @returns Record<T, string> - A record where keys are the input strings, and values are their uppercase counterparts.
 * 
 * @example
 * createActionTypes(["ABC_SOMETHING", "AbC"]);
 * // Returns: { ABC_SOMETHING: "ABC_SOMETHING", AbC: "ABC" }
 */
export const createActionTypes = <T extends string>(types: T[]): Record<T, string> => {
    return types.reduce((acc, key) => {
        acc[key] = key.toUpperCase();
        return acc;
    }, {} as Record<T, string>);
};
